export default "__VITE_ASSET__zRvLAWQm__"